import { Component, Inject, OnInit } from '@angular/core';
import { NotesComponent } from '../notes.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MeetingNotesService } from 'src/app/services/meetingNotes/meeting-notes.service';
import { ToastrService } from 'ngx-toastr';
import { NotesRefreshService } from 'src/app/services/notes/notesrefresh.service';

@Component({
  selector: 'app-delete-note-confirmation-dialog',
  templateUrl: './delete-note-confirmation-dialog.component.html',
  styleUrls: ['./delete-note-confirmation-dialog.component.scss'],
})
export class DeleteNoteConfirmationDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DeleteNoteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string; noteId: string },
    public meetingNotesService: MeetingNotesService,
    public toaster: ToastrService,
    public notesRefreshService: NotesRefreshService
  ) {}

  ngOnInit(): void {}

  onCancel() {
    this.dialogRef.close(false); // Return false when user cancels
  }

  deleteNote(noteId: string): void {
    this.meetingNotesService.deleteNotesById(noteId).subscribe({
      next: (response) => {
        this.dialogRef.close(true);
        this.toaster.success('Note deleted successfully');
        this.notesRefreshService.triggerRefresh();
        //this.loadMeetingNotes(); // Refresh the list
      },
      error: (err) => {
        console.error('Error deleting note:', err);
        this.toaster.error('Failed to delete note');
        this.dialogRef.close(true);
      },
    });
  }
}
